module.exports = __webpack_public_path__ + "img/bg@2x.f16bd6b9.png";